import {useEffect, useRef} from "react";

import {useOfferListingAbroadView} from "../../offer/list/hooks/use_offer_listing_abroad_view_check";
import {tdaInternalBanners, tdaInternalSpanishEbookBanner} from "../constants/tda_internal_banners";

export function useTdaPlaceholderBanner() {
    const randomIndexRef = useRef<number | null>(null);
    const isAbroad = useOfferListingAbroadView();

    useEffect(() => {
        randomIndexRef.current = Math.floor(Math.random() * 2);
    }, []);

    if (isAbroad) {
        return tdaInternalSpanishEbookBanner;
    }

    if (typeof randomIndexRef.current === "number") {
        return tdaInternalBanners[randomIndexRef.current];
    }
}
